<template>
  <div class="container my-account">
    <AppBreadcrumbs />
    <h1
      class="my-account__title heading heading--1"
      v-text="$t('Create new customer account')"
    />
    <AccountAuthGuard>
      <template #loading>
        <p>
          Successfully created account! <span v-if="loginLoading"> - logging in ...</span>
        </p>
      </template>

      <template #logged-in>
        Al geregistreerd. <AppLink :to="'/account/'">
          Ga naar je account gegevens.
        </AppLink>
      </template>

      <template #not-logged-in>
        <div class="my-account__wrapper">
          <div class="my-account__content">
            <div class="my-account__register">
              <h2
                class="my-account__heading heading heading--2"
                v-text="$t('New customers')"
              />

              <AccountCreate
                :auto-login="true"
                @success="goToLogin()"
              />
            </div>

            <div class="my-account__login">
              <h2
                class="my-account__heading heading heading--2"
                v-text="$t('Registered customers')"
              />
              <div class="my-account__text">
                <p v-text="$t('Already have an account?')" />
              </div>
              <AppLink
                :to="'/account/'"
                class="button"
                :class="{ 'button--shop-flow button--full': travelbagsOnly }"
              >
                <span>{{ $t('Login') }}</span>
              </AppLink>
            </div>
          </div>
        </div>
      </template>
    </AccountAuthGuard>
  </div>
</template>

<script setup>
import { useBreadcrumbs } from '~layers/app/composables/useBreadcrumbs.ts'

const { public: config } = useRuntimeConfig()
const { loginLoading } = useAccountLogin()
const { t } = useI18n({ useScope: 'global' })
const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: t('Create'),
  parents: [
    {
      label: t('Account'),
      url: 'account',
    },
  ],
})

const goToLogin = () => {
  console.log('go to login')
  navigateTo('/account/')
}

const { pageView } = useDataLayer()
pageView('other', t('Register'))

const travelbagsOnly = computed(
  () => config.storeHeader.startsWith('tra'),
)

useHead({
  meta: [
    { name: 'robots', content: 'noindex, follow' },
  ],
})
</script>

<style>
@import url("~layers/app/pages/account.css");
</style>
